import { useMemo } from 'react';

import dayjs from 'dayjs';

import { Icons, Box, Stack } from '@cast/design-system';

import { generateEmptyTimeSeries } from 'utils/data/generateEmptyTimeSeries';

import { CostReportChart, CostReportChartProps } from './CostReportChart';

import { NoData } from '@cast/shared-search-ui';

export const CostReportChartNoResults = <T extends object>(
  props: CostReportChartProps<T>
) => {
  const emptyChartData = useMemo(() => {
    return generateEmptyTimeSeries({
      range: [dayjs().startOf('month'), dayjs().endOf('month')],
    });
  }, []);

  return (
    <Box sx={{ position: 'relative' }}>
      <CostReportChart
        {...props}
        config={[]}
        yAxisProps={{
          ticks: [0, 50, 100, 150, 200],
        }}
        data={emptyChartData}
      />
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      >
        <NoData
          icon={<Icons.Question />}
          title="No data available"
          sx={{ marginTop: 0 }}
        />
      </Stack>
    </Box>
  );
};
